import React from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import TrustBar from "../components/TrustBar";
import Services from "../components/Services";
import HowWeWork from "../components/HowWeWork";
import TechDepth from "../components/TechDepth";
import CaseStudies from "../components/CaseStudies";
import ThoughtLeadership from "../components/ThoughtLeadership";
import Talent from "../components/Talent";
import FinalCTA from "../components/FinalCTA";
import Footer from "../components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-[#EDF1FB]">
      <Navbar />
      <main>
        <Hero />
        <TrustBar />
        <Services />
        <HowWeWork />
        <TechDepth />
        <CaseStudies />
        <ThoughtLeadership />
        <Talent />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
